import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import i18n from './i18n/i18n'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import './assets/css/style.css'
import './assets/css/iconfont/iconfont.css'

// import VueFullscreen from 'vue-fullscreen';
// Vue.use(VueFullscreen); // 使用插件

// import { monitorZoom} from "@/utils/monitorZoom.js";
// browserZoom
// 


import disableDevtool from 'disable-devtool'

disableDevtool(
   {
    ondevtoolopen: function() {
      window.location.href = 'https://www.citygroup.com.cn/#/error';
    }
  }
)

/* 调整缩放比例 start */

// const m = monitorZoom();

// if (window.screen.width * window.devicePixelRatio >= 3840) {

//   document.body.style.zoom = 100 / (Number(m) / 2); // 屏幕为 4k 时

// } else {
//     // alert(m)
//   if (m == 125) {
//     document.body.style.zoom = 100 / Number(m - 21);
//   } else if (m == 150) {
//     document.body.style.zoom = 100 / Number(m - 43);
//   } else {
//     document.body.style.zoom = 100 / Number(m);
//   }
// }

// /* 调整缩放比例 end */
var screenWidth = window.innerWidth;
  // 根据屏幕宽度计算新的根元素字体大小
  var newFontSize = screenWidth / 100; // 假设每个rem相当于屏幕宽度的1/20
  // 更新根元素的字体大小
  document.documentElement.style.fontSize = newFontSize + 'px';

window.addEventListener('resize', function() {
  var screenWidth = window.innerWidth;
  // 根据屏幕宽度计算新的根元素字体大小
  var newFontSize = screenWidth / 100; // 假设每个rem相当于屏幕宽度的1/20
  // 更新根元素的字体大小
  document.documentElement.style.fontSize = newFontSize + 'px';
});

// const zoomSize = browserZoom();
// alert(zoomSize)
// if (zoomSize != 1) {
//     // alert('当前窗口不是100%，请在浏览器上设置回100%转态')
//     // document.body.style.zoom  = 1
//     // 方法1: 使用CSS transform进行视觉重置
//     // const inverseScale = 1 / zoomSize;
//     // document.documentElement.style.transform = `scale(${inverseScale})`;
//     // document.documentElement.style.transformOrigin = '0 0';
//     // document.documentElement.style.width = `${100 * zoomSize}%`;
//     // document.documentElement.style.height = `${100 * zoomSize}%`;
    
//     // // 方法2: 尝试通过修改视口 (对移动端更有效)
//     // const viewportMeta = document.querySelector('meta[name="viewport"]');
//     // if (viewportMeta) {
//     //     viewportMeta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no';
//     // }

// }
// alert(zoomSize)
// detectZoom() {
//     let zoom = 1;
    
//     // 方法1: 通过window尺寸计算 (最可靠)
//     if (window.outerWidth && window.innerWidth) {
//         zoom = window.outerWidth / window.innerWidth
//     }
//     // 方法2: 通过devicePixelRatio (备选)
//     else if (window.devicePixelRatio) {
//         zoom = window.devicePixelRatio
//     }
    
//     // 处理极端值
//     zoom = Math.round(zoom * 100) / 100
//     if (zoom < 0.1) zoom = 0.1
//     if (zoom > 5) zoom = 5
    
//     // 更新显示
//     updateZoomDisplay(zoom)
    
//     return zoom
// }



// Vue.directive('disable-context-menu', {
//   bind(el) {
//     el.addEventListener('contextmenu', (event) => {
//       event.preventDefault();
//     });
//   },
//   unbind(el) {
//     el.removeEventListener('contextmenu');
//   }
// });

// window.addEventListener('orientationchange', function() {
//   if (window.orientation === 90 || window.orientation === -90) {
//     // 横屏，允许
//   } else {
//     // 竖屏，尝试旋转回横屏
//     if (screen.orientation) {
//       screen.orientation.lock('landscape').catch(function(error) {
//         console.error('Failed to lock the orientation. Error: ' + error);
//       });
//     } else {
//       console.error('Screen Orientation API is not supported.');
//     }
//   }
// })

// Vue.config.devtools = false

document.addEventListener('keydown', function(event) {
    // 检查是否是F12键
    if (event.key === 'F12') {
        // 阻止默认行为（例如打开开发者工具）
        event.preventDefault();

        // 可以选择显示一个警告信息
        // alert('开发者工具已被禁用。');
    }
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
